// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-n_gh","galleryThumbnail_active":"c-n_gi","galleryThumbnail__image":"c-n_gj"};